import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscription', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-14 sm:pt-20" style={{
    paddingTop: "20px"
  }} data-id="element-106" data-mp="9llb731mq8q5">
      <div className="mx-auto max-w-4xl text-center" data-id="element-107" data-mp="4n1jem0cu2pv">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="font-display text-[2.6rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.5rem]" data-id="element-108" data-mp="1297cg4ndx19u">
          Solve a Full Year of Math Class in Just{' '}
          <span className="italic text-brand" data-id="element-109" data-mp="nbomx02vuk1c">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-ink/60 sm:mt-6 sm:text-lg" style={{
        marginTop: "20px"
      }} data-id="element-110" data-mp="3d2ldtocrhr6i">
          Join 2,000+ math teachers who stopped improvising. Walk into every
          class with everything ready to teach, solve, and inspire.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.18,
        ease: 'easeOut'
      }} className="mx-auto mt-2 max-w-2xl sm:mt-8" data-id="element-111" data-mp="39cpboqkkxd0s">
          <img src="https://cdn.magicpatterns.com/uploads/aJ5hqaN3VeNSMELHiz1KVt/5d7d771c-a6b7-407e-9daf-232b532d381a.webp" alt="The Math Ready pack shown across printed volumes, desktop, tablet and phone" className="w-full" style={{
          paddingBottom: "20px",
          paddingTop: "10px"
        }} data-id="element-112" data-mp="359syjfdt6948" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.28,
        ease: 'easeOut'
      }} className="-mt-2 sm:mt-8" data-id="element-113" data-mp="2hkgibvk2d0sf">
          <CtaButton href="#offer" data-id="element-114" data-mp="s3cm2bn71lr3" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-115" data-mp="nbl2il2gggag">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-116" data-mp="ia5kz2zhkrwt" data-mpi={index}>
                <span data-id="element-117" data-mp="dege0el508qh">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-118" data-mp="1b1fel0eya0tn">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}